import React, { useEffect, useState, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import axios from "axios";
import "../../style/contactPage/contactpage.scss";
import Header from "../contact_page/contact_header";
import Footer from "../work/footer";
import { UserContext } from "../../use_context";

const JobDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [email, setEmail] = useState("");
  const [file, setFile] = useState(null);
  // const [careerData, setCareerData] = useState([]);
  const { careerData, setCareerData } = useContext(UserContext);

  const [error, setError] = useState("");
  const [status, setStatus] = useState({ type: null, message: "" });

  const API_BASE_URL = process.env.REACT_APP_SEARCH_API;

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setError("");
  };

  const validate = () => {
    if (!email.trim()) {
      setError("Email is required.");
      return false;
    } else if (!/^\S+@\S+\.\S+$/.test(email)) {
      setError("Enter a valid email.");
      return false;
    }

    if (!file) {
      setError("Please upload your CV or file.");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    const formData = new FormData();
    formData.append("_wpcf7_unit_tag", "768");
    formData.append("youremail", email);
    formData.append("yourfile", file);

    try {
      const response = await fetch(
        "https://infoglans.com/search/wp-json/contact-form-7/v1/contact-forms/768/feedback",
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();

      if (result.status === "mail_sent") {
        setStatus({
          type: "success",
          message: result.message || "Message sent!",
        });
        setEmail("");
        setFile(null);
        setShowModal(false);
      } else {
        setStatus({
          type: "error",
          message: result.message || "Something went wrong.",
        });
      }
    } catch (err) {
      setStatus({
        type: "error",
        message: "Server error. Please try again later.",
      });
    }
  };

  useEffect(() => {
    if (careerData?.length > 0) return;

    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/pages/110`);
        const data = response.data;
        const careers = Array.isArray(data?.acf?.career) ? data.acf.career : [];
        setCareerData(careers);
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };
    fetchData();
  }, []);

  const careerDetail = careerData.find((c, i) => i.toString() === id);

  return (
    <div>
      <Header />
      <Container className="py-5 mt-5">
        <div className="job-details-container">
          <h1 className="job-title">{careerDetail?.career_title}</h1>
          <p className="job-subtitle">{careerDetail?.career_desc}</p>

          <button className="submit-btn" onClick={() => setShowModal(true)}>
            {careerDetail?.career_button || "Submit CV"}
          </button>

          {showModal && (
            <div className="modal-overlay">
              <div className="modal">
                <h2>Submit Your CV</h2>
                <form onSubmit={handleSubmit}>
                  <input
                    type="email"
                    name="youremail"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      setError("");
                    }}
                    required
                  />

                  <input
                    type="file"
                    name="yourfile"
                    onChange={handleFileChange}
                    accept=".pdf,.doc,.docx,.jpg,.png"
                    required
                  />

                  <p
                    style={{ marginTop: 0, fontSize: "0.9rem", color: "#555" }}
                  >
                    You can upload your CV or portfolio (PDF, DOC, Images)
                  </p>

                  {error && <p className="text-danger">{error}</p>}
                  {status.message && (
                    <p
                      className={
                        status.type === "error" ? "text-danger" : "text-success"
                      }
                    >
                      {status.message}
                    </p>
                  )}

                  <div className="modal-buttons">
                    <button type="submit">Submit</button>
                    <button type="button" onClick={() => setShowModal(false)}>
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

          <br />
          <div className="back-link" onClick={() => navigate("/contact")}>
            <ArrowLeft size={16} className="back-icon" />
            <span>Back to Career</span>
          </div>
        </div>
      </Container>

      <Container className="leadership-align">
        {careerDetail?.career_details?.heading?.map((headingItem, i) => (
          <Row key={i} className="mb-5 summary-border mt-5">
            <Col md={3}>
              <h5 className="fw-semibold">{headingItem?.titel}</h5>
            </Col>
            <Col md={9}>
              <ul className="pb-5">
                {headingItem?.desc?.map((descItem, j) => (
                  <li key={j}>{descItem?.points_1}</li>
                ))}
              </ul>
            </Col>
          </Row>
        ))}

        <div className="justify-content-center d-flex">
          <button className="submit-btn" onClick={() => setShowModal(true)}>
            Submit CV
          </button>
        </div>
      </Container>

      <Footer />
    </div>
  );
};

export default JobDetails;
